'use client';

import { useEffect } from 'react';
import { useUser, useClerk } from '@clerk/nextjs';

const AuthButton = () => {
  const { user } = useUser();
  const { openSignIn } = useClerk();

  const redirectToDashboard = (role: string) => {
    const dashboardPaths: Record<string, string> = {
      admin: '/admin',
      formator: '/admin',
      media: '/list/news',
      seminarian: '/seminarian',
      lecturer: '/lecturer',
    };

    window.location.href = dashboardPaths[role] || '/';
  };

  const handleClick = () => {
    if (user) {
      const role = user.publicMetadata?.role as string || '';
      redirectToDashboard(role);
    } else {
      window.location.href = '/login';
    }
  };
  return (
    <button className="public-hero-btn" onClick={handleClick}>
      {user ? 'Dashboard' : 'Log In'}
    </button>
  );
};

export default AuthButton;